export default {
  'ConcertMainParagraphPreSocials': {
    en: 'It is very easy to request a concert! All you need to do is send us your name and phone number via private message to our ',
    es: 'Recibir un mini-concierto de Música para Respirar 24/7 es fácil, solo necesitas escribirnos por mensaje interno a nuestras redes sociales en ',
    pt: 'Receber um mini-concerto é muito fácil! É só enviar seu nome e número de WhatsApp por mensagem às nossas páginas de ',
  },
  'or': {
    en: ' or ',
    es: ' o ',
    pt: ' ou '
  },
  'ConcertMainParagraphPostSocials': {
      en: ' accounts during the week of Música para Respirar 24/7. Within 30 minutes, one of our musicians will contact you and perform a live concert through the video-calling platform of your choice. The concerts are available 24/7 and last around 20 minutes.',
      es: ' durante las semanas de Música para Respirar 24/7. Uno de nuestros músicos te contactará y realizará un concierto en vivo para tí a través de Zoom, Whatsapp o la plataforma de video-llamada de tu preferencia. Los conciertos están disponibles 24 horas al día y duran alrededor de 20 minutos.',
    pt: ' durante as semanas de Música para Respirar 24/7. Um de nossos músicos entrará em contato e realizará um concerto ao vivo para você através do Zoom, WhatsApp ou a plataforma de videochamada de sua preferência. Os concertos estão disponíveis as 24 horas do dia e duram ao redor de 20 minutos.',
  },
  'pide': {
    en: 'REQUEST',
    es: 'PIDE TU',
    pt: 'PEÇA SEU',
  },
  'concierto': {
    en: 'A CONCERT',
    es: 'CONCIERTO',
    pt: 'CONCERTO',
  },
  "vive la música en casa": {
    en: "live the music at home",
    es: "vive la música en casa",
    pt: "viva a musica em casa"
  },
  "typesOfConcerts": {
    en: "TYPES OF CONCERTS",
    es: "TIPOS DE CONCIERTOS",
    pt: "TIPOS DE CONCERTOS"
  },
    "CONCERTS": {
    en: "CONCERTS",
    es: "CONCIERTOS",
    pt: "CONCERTOS"
  },
    "TYPESOF": {
    en: "TYPES OF",
    es: "TIPOS DE",
    pt: "TIPOS DE"
  },

    "PERSONAL": {
    en: "PERSONAL",
    es: "CONCIERTOS PERSONALES",
    pt: "CONCERTO PESSOAL"
  },
    "INSTITUTIONAL": {
    en: "INSTITUTIONAL",
    es: "CONCIERTOS INSTITUCIONALES",
    pt: "CONCERTOS INSTITUCIONAIS"
  },
    "GIFTACONCERT": {
    en: "GIFT A CONCERT",
    es: "CONCIERTOS DE REGALO",
    pt: "CONCERTO DE PRESENTE"
  },
    "TIPSFORCONCERT": {
    en: "TIPS FOR THE CONCERT",
    es: "TIPS PARA TU CONCIERTO",
    pt: "DICAS PARA O CONCERTO"
  },
  "personalConcertTextP1": {
    en: "This is the ideal 1:1 Música para Respirar 24/7 experience. Request an immediate concert by writing a private message with your name and phone number to ",
    es: "Un concierto sólo para ti. Durante las semanas de Música para Respirar 24/7, pide un concierto inmediato enviando un mensaje interno con tu nombre y número de Whatsapp a ",
    pt: "Esta é a experiência 1:1  ideal de Música para Respirar 24/7. Peça um concerto pessoal imediato enviando uma mensagem com seu nome e número de WhatsApp no "
  },
    "personalConcertTextP2": {
    en: " and a musician will contact you within 30 minutes. You can also schedule your concert for a time that suits you during the week of Música para Respirar 24/7.",
    es: " y un músico te contactará en hasta 30 minutos. También puedes programarlo para un horario que te convenga durante esa semana.",
    pt: " e um músico te contactará em até 30 minutos. Você também pode agendar um concerto para um melhor horário durante as semanas de Música para Respirar 24/7."
  },
    "institutionalConcertTextP1": {
    en: "Música para Respirar 24/7 also provides concerts to schools, hospitals, retirement homes,  orphanages and any other organization that offers social support. These concerts can be organized for groups or individually. To find more details about these please read the ",
    es: "Música para Respirar 24/7 brinda conciertos a instituciones cómo clínicas, hospitales, escuelas, universidades, centros del adulto mayor, entre otras. Estos conciertos pueden realizarse de manera grupal o personal. Para más información acerca de los conciertos institucionales puedes leer ",
    pt: "Música para Respirar 24/7 realiza concertos para escolas, hospitais, lar de idosos, orfanatos e qualquer organização que ofereça apoio social. Estes concertos podem ser organizados em grupos ou individualmente. Para mais informações visite  "
  },
    "institutionalConcertTextP2": {
    en: " and contact us at: ",
    es: " y contactarnos a: ",
    pt: " e entre em contato através do email: "
  },
  'thepresentation': {
    en: 'Institutional Concerts Booklet',
    es: 'la siguiente presentación',
    pt: 'o Booklet de Concertos Institucionais'
  },
    "giftConcertTextP1": {
    en: "If you would like to send a concert to a loved one, you only need to send us their contact information via our ",
    es: "Envía un concierto a un ser querido, solo necesitas mandarnos su nombre, su número de teléfono y la hora que deseas que lo contactemos por mensaje privado a ",
    pt: "Se você gostaria de enviar um concerto para uma pessoa querida, só precisa nos enviar seus dados de contato através de nossas páginas de "
  },
  "giftConcertTextP2": {
    en: " pages and we will get in touch with them. For this type of concert, we ask you to let your loved one know they will be receiving a very special treat at the specific time, in order to avoid problems of communication and timing.",
    es: ". Es importante que le avises que esté atento a recibir una sorpresa especial alrededor del horario combinado.",
    pt: " e nós entraremos em contato com eles. Para este tipo de concerto, pedimos que comunique ao ouvinte que receberá um presente muito especial na hora específica, para evitar problemas de comunicação e timing."
  },
    "tipsConcertText1": {
    en: "Make sure your Wifi connection is working properly and try to be close to your router if possible",
    es: "Asegúrate que tu internet esté funcionando correctamente y si es posible acomódate cerca del router",
    pt: "Verifique se sua internet está funcionando corretamente e se possível, tente estar próximo ao roteador"
  },
      "tipsConcertText2": {
    en: "Sound quality is often better on ZOOM video-calls, so we recommend you download the app if you  don't already have it",
    es: "La calidad de sonido en las videollamadas de Zoom es mejor. Si todavía no tienes la aplicación te recomendamos descargarla a tu celular o computadora",
    pt: "A qualidade de som nas videochamadas do Zoom é melhor. Assim, recomendamos o download do aplicativo se você ainda não o tem"
  },
      "tipsConcertText3": {
    en: "Use headphones if you have them to enhance the experience of your concert",
    es: "Si tienes audífonos a la mano no dudes en usarlos para mejorar aún más la calidad de sonido de tu concierto",
    pt: "Use fones de ouvido ou amplificadores para melhorar ainda mais a qualidade de som do seu concerto"
  },
      "tipsConcertText4": {
    en: "Please remember to  mute your microphone during the performance to improve sound quality",
    es: "Acuérdate de colocar tu micrófono en mudo durante las piezas musicales, mejorará la calidad de sonido",
    pt: "Lembre-se de desligar seu microfone quando a música começar"
  },
      "tipsConcertText5": {
    en: "All our musicians will be very happy to talk to you, so feel free to ask any questions before, during or after the performance",
    es: "Todos nuestros músicos y músicas están felices de conversar contigo, saber qué tipo de música te gusta y responder cualquier pregunta que tengas",
    pt: "Nossos músicos estarão felizes em conversar com você, por isso sinta-se à vontade para fazer perguntas antes, durante ou depois da performance"
  },


}
